import apiClient from './apiClient';
import type {
    VehicleTemplate,
    CreateVehicleTemplateDto,
    UpdateVehicleTemplateDto
} from '../../types/model/vehicle-template.model';

/**
 * Respuesta estándar de la API
 */
interface ApiResponse<T> {
    success: boolean;
    data: T;
    message?: string;
}

export const vehicleTemplatesService = {
    /**
     * Obtiene todos los templates de vehículos
     * @returns Lista de templates
     */
    getAll: async (): Promise<VehicleTemplate[]> => {
        const response = await apiClient.get<ApiResponse<VehicleTemplate[]>>('/vehicle-templates');
        return response.data.data;
    },

    /**
     * Obtiene un template por su ID
     * @param id - ID del template
     * @returns Template encontrado
     */
    getById: async (id: string): Promise<VehicleTemplate> => {
        const response = await apiClient.get<ApiResponse<VehicleTemplate>>(`/vehicle-templates/${id}`);
        return response.data.data;
    },

    /**
     * Crea un nuevo template
     * @param data - Datos del template
     * @returns Template creado
     */
    create: async (data: CreateVehicleTemplateDto): Promise<VehicleTemplate> => {
        const response = await apiClient.post<ApiResponse<VehicleTemplate>>('/vehicle-templates', data);
        return response.data.data;
    },

    /**
     * Actualiza un template existente
     * @param id - ID del template
     * @param data - Datos a actualizar
     * @returns Template actualizado
     */
    update: async (id: string, data: UpdateVehicleTemplateDto): Promise<VehicleTemplate> => {
        const response = await apiClient.put<ApiResponse<VehicleTemplate>>(`/vehicle-templates/${id}`, data);
        return response.data.data;
    },

    /**
     * Elimina un template
     * @param id - ID del template
     * @returns true si se eliminó correctamente
     */
    delete: async (id: string): Promise<boolean> => {
        await apiClient.delete(`/vehicle-templates/${id}`);
        return true;
    },
};

export default vehicleTemplatesService;
